export function createActionTypes(listActions) {
    const actionTypes = {};
    listActions.forEach(action => {
        actionTypes[action] = action.toUpperCase();
        ['Success', 'Failed'].forEach(status => actionTypes[`${action}${status}`] = `${action}${status}`.toUpperCase());
    });
    return actionTypes;
}

export type ReduxAction = { type: string, payload: {} | string };

export function createActions(listActions, actionTypes) {
    const actions = {};
    listActions.forEach(action => {
        actions[action] = (payload: {}): ReduxAction => {
            return {
                type: actionTypes[action],
                payload,
            }
        };
        ['Success', 'Failed'].forEach(status => {
            actions[`${action}${status}`] = (payload): ReduxAction => {
                return {
                    type: actionTypes[`${action}${status}`],
                    payload,
                }
            }
        });
    });
    return actions;
}

export function createRedux(listActions, reducerFunc) {
    const actionTypes = createActionTypes(listActions);
    const actions = createActions(listActions, actionTypes);
    return {actionTypes, actions};
}
